import styled from 'styled-components';

export const Droparea = styled.div`
    border: 2px dashed #ccc;
    border-radius: 20px;
    width: 480px;
    font-family: sans-serif;
    margin: 100px auto;
    padding: 20px;
`;

export const StyledForm = styled.form`
    margin-bottom: 10px;
`;

export const StyledLabel = styled.label`
    display: inline-block;
    padding: 10px;
    background: #ccc;
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid #ccc;

    :hover {
        background: #ddd;
    }
`;

export const StyledInput = styled.input`
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);

    :focus + label {
        outline: thin dotted;
    }
    :focus-within + label {
        outline: thin dotted;
    }
`;

export const StyledText = styled.p`
    margin-top: 0;
    `;